/* eslint-disable react/prop-types */
import React from "react";
import styled, { ThemeProvider } from "styled-components";
import theme from "styled-theming";
import {  Icon } from "../assets/icons";

const buttonBackground = theme.variants("mode", "variant", {
  primary: { main: (props) => props.theme.buttons.primary.background },
  distress: { main: (props) => props.theme.buttons.distress.background },
  distressactive: {
    main: (props) => props.theme.buttons.distressactive.background,
  },
  blue: { main: (props) => props.theme.buttons.blue.background },
});

const buttonHover = theme.variants("mode", "variant", {
  primary: { main: (props) => props.theme.buttons.primary.hover },
  distress: { main: (props) => props.theme.buttons.distress.hover },
  distressactive: { main: (props) => props.theme.buttons.distressactive.hover },
  blue: { main: (props) => props.theme.buttons.blue.hover },
});

const buttonDisabled = theme.variants("mode", "variant", {
  primary: { main: (props) => props.theme.buttons.primary.disabled },
  distress: { main: (props) => props.theme.buttons.distress.disabled },
  distressactive: {
    main: (props) => props.theme.buttons.distressactive.disabled,
  },
  blue: { main: (props) => props.theme.buttons.blue.disabled },
});

const buttonColorDisabled = theme.variants("mode", "variant", {
  primary: { main: (props) => props.theme.buttons.primary.disabledColor },
  distress: { main: (props) => props.theme.buttons.distress.disabledColor },
  distressactive: {
    main: (props) => props.theme.buttons.distressactive.disabledColor,
  },
  blue: { main: (props) => props.theme.buttons.blue.disabledColor },
});

const buttonColor = theme.variants("mode", "variant", {
  primary: { main: (props) => props.theme.buttons.primary.color },
  distress: { main: (props) => props.theme.buttons.distress.color },
  distressactive: { main: (props) => props.theme.buttons.distressactive.color },
  blue: { main: (props) => props.theme.buttons.blue.color },
});

const buttonBorder = theme.variants("mode", "variant", {
  primary: { main: (props) => props.theme.buttons.primary.borderColor },
  distress: { main: (props) => props.theme.buttons.distress.borderColor },
  distressactive: {
    main: (props) => props.theme.buttons.distressactive.borderColor,
  },
  blue: { main: (props) => props.theme.buttons.blue.borderColor },
});

const buttonBorderRadius = theme.variants("mode", "variant", {
  primary: { main: (props) => props.theme.buttons.primary.borderRadius },
  distress: { main: (props) => props.theme.buttons.distress.borderRadius },
  distressactive: {
    main: (props) => props.theme.buttons.distressactive.borderRadius,
  },
  blue: { main: (props) => props.theme.buttons.blue.borderRadius },
});

const Btn = styled.button`
font-weight: bold;
font-size: 2vw;
text-transform: uppercase;
cursor: pointer;

height: auto;
width: 15%;
margin: 40px;
border: none;
outline: none;
padding-top: 20px;
padding-bottom: 20px;
box-shadow: 3px 5px 5px;
border-color: ${buttonBorder};
background-color: ${buttonBackground};
color: ${buttonColor};
border-radius: ${buttonBorderRadius};

  &.hover {
    @media only screen and (min-width: 601px){
      padding: 3px
    }
    border: 3px solid ${buttonHover};
  }

  &.focus {
    /* Visible in the full-colour space */
    box-shadow: 0px 0px 6px 6px ${buttonHover};
    outline: none;
    background-color:${buttonHover};
    color: #005A4B;
    fill: #005A4B;
  }
    :active{
      background-color:${buttonHover};
      color: #005A4B;
    }
    :focus-within
      .disabled,
      :disabled {
        /* color: ${buttonColorDisabled};
        background: ${buttonDisabled};
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-color: ${buttonDisabled}; */
        text-decoration: none;
        cursor: not-allowed;
    }  
 
    @media screen and (max-width: 600px) {
    height: auto;
    width: 80%;
    font-size: 20px;
    display: flex;
    margin-top: 0.2px;
    margin-bottom: 15px;
  }
  `;


const disableClick = () => console.log("Click disabled");

class Button extends React.Component { 
  constructor(props) {
    super(props);
    /*
    const {
      mode,
      main,
      variant,
      type,
      style,
      onClick,
      disabled,
      className,
      noicon,
      icon,
      notext,
      name,
      label,
    } = props;
    */

    this.newVariant = this.props.disabled ? "disabled" : this.props.variant;
    this.ftn = this.props.disabled ? disableClick : this.props.onClick;
  }

  render() {
    return (
    <ThemeProvider theme={{ mode: this.props.mode ? this.props.main : "main" }}>
      <Btn
        variant={this.newVariant}
        type={this.props.type || "button"}
        name={this.props.name}
        style={this.props.style}
        onClick={this.ftn}
        disabled={this.props.disabled}
        className={this.props.className}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
      >
        {this.noicon ? null : (
          <Icon
            noicon={this.props.noicon}
            icon={this.props.icon}
            variant={this.props.variant || "primary"}
            notext={this.props.notext}
            disabled={this.props.disabled}
          />
         
        )}
        {this.props.label}
        {this.props.children}
      </Btn>
    </ThemeProvider>
    );
  }
}

export default Button;

Button.defaultProps = {
  variant: "primary"
};
